import { render, staticRenderFns } from "./PoliciesIssuedBreakdown.vue?vue&type=template&id=5f428c39&"
import script from "./PoliciesIssuedBreakdown.vue?vue&type=script&lang=js&"
export * from "./PoliciesIssuedBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VList,VListItem,VSpacer})
